// lbs
import { useNavigate } from 'react-router-dom';

// components
import CustomButton from '../../components/CustomButton';

// styles
import classes from './styles.module.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div className={classes.root}>
      <div className={classes.box}>
        <h2 className={classes.errNum}>404</h2>
        <p className={classes.errText}>Страница не найдена</p>
        <CustomButton onClick={goBack} text="Вернуться" className={classes.button} />
      </div>
    </div>
  )
}